import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Students.Data.StudentData[]> {
  return axios.get(route('api.global.search', filters)).then((res) => res.data);
}
